export default class Mercure {
    private currentDelay: number = 0;
    private maxDelay: number = 180000; // 3 minutes

    public addListener(topic: string, callback: (e: MessageEvent) => void): void {
        const html = document.querySelector('html');
        const url = html.getAttribute('data-mercure-hub-url');
        const prefix = html.getAttribute('data-mercure-prefix');
        this.connectToEventSource(`${url}?topic=${prefix}/${topic}`, callback);
    }

    private connectToEventSource(url: string, callback: (e: MessageEvent) => void): void {
        const es = new EventSource(url, { withCredentials: true });
        es.onmessage = callback;
        es.addEventListener('open', () => this.currentDelay = 0);
        es.addEventListener('error', () => this.handleError(es, url, callback));
        window.addEventListener('beforeunload', () => es.close());
    }

    private async handleError(es: EventSource, url: string, callback: (e: MessageEvent) => void): Promise<void> {
        if (es.readyState === EventSource.CONNECTING) {
            this.refreshCookie();
        }
        if (es.readyState === EventSource.CLOSED) {
            await this.refreshCookie();
            this.connectToEventSource(url, callback);
        }
    }

    private async refreshCookie(): Promise<void> {
        let response: Response;
        do {
            response = await fetch('/');
            await this.delay(this.currentDelay);
            this.currentDelay = Math.min(this.currentDelay + 2000, this.maxDelay);
        } while (!response.ok);
    }

    private delay(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}
